import { render } from "./TestingTab.vue?vue&type=template&id=3df2463b"
import script from "./TestingTab.vue?vue&type=script&lang=js"
export * from "./TestingTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__